import { connect } from 'react-redux';
import { externalPrototypeLoaded, externalPrototypeLoading, } from '../actionCreators/externalPrototype';
import ExternalPrototype from '../components/ExternalPrototype';
import { getHasLoadedExternalPrototype, getProjectScreens } from '../selectors';
function mapStateToProps(state) {
    return {
        goalScreenPk: state.replay.goalScreenPk,
        hasLoadedExternalPrototype: getHasLoadedExternalPrototype(state),
        screens: getProjectScreens(state),
        loadingStatus: state.hasLoadedExternalPrototype,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        setHasLoadedExternalPrototype: function () {
            dispatch(externalPrototypeLoaded());
        },
        setExternalPrototypeLoading: function () {
            dispatch(externalPrototypeLoading());
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExternalPrototype);
